export const redirects = {
  "/account/schedule": "/account",
};
